/* HENOR: conserva permiso y referencia de clic en el carrito. No envia eventos a OpenAI.
 * Instalar como asset del tema, NO como pixel personalizado. No contiene claves.
 * Requiere un banner que comunique las decisiones a Shopify.customerPrivacy.
 */
(() => {
  'use strict';
  if (window.__henorOpenAIAttribution) return;
  window.__henorOpenAIAttribution = true;
  const storageKey = 'henor_openai_ref_v1';
  const prefix = '__henor_openai_';
  const nativeFetch = window.fetch.bind(window);
  const root = window.Shopify?.routes?.root || '/';
  let running = Promise.resolve();
  let lastWritten = '';
  let pending = false;

  function allowed() {
    const privacy = window.Shopify?.customerPrivacy;
    return Boolean(privacy && privacy.marketingAllowed() === true &&
      privacy.analyticsProcessingAllowed() === true && privacy.saleOfDataAllowed() === true);
  }
  function removeStored() {
    try { window.localStorage.removeItem(storageKey); } catch (_) { /* Almacenamiento no disponible. */ }
  }
  function reference() {
    if (!allowed()) { removeStored(); return ''; }
    // No usar URLSearchParams: oppref es un valor opaco y se conserva sin decodificar.
    const match = window.location.search.match(/(?:^|[?&])oppref=([^&]*)/);
    if (match && match[1] && match[1].length <= 4096 && !/[\x00-\x1f]/.test(match[1])) {
      const record = { value: match[1], expires: Date.now() + 30 * 86400000 };
      try { window.localStorage.setItem(storageKey, JSON.stringify(record)); } catch (_) { /* Mantener referencia de esta URL. */ }
      return record.value;
    }
    try {
      const old = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
      if (old && typeof old.value === 'string' && old.expires > Date.now() && old.value.length <= 4096 &&
          !/[\x00-\x1f]/.test(old.value)) return old.value;
    } catch (_) { /* Sin referencia guardada. */ }
    removeStored();
    return '';
  }
  async function update() {
    const permitted = allowed();
    const ref = reference();
    const response = await nativeFetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) return;
    const cart = await response.json();
    // Evitar crear carritos vacios para visitantes que solo navegan.
    if (!cart.item_count) return;
    const attributes = {
      [prefix + 'consent']: permitted ? 'granted' : 'denied',
      [prefix + 'oppref']: permitted ? ref : '',
      [prefix + 'captured_at']: new Date().toISOString(),
    };
    const fingerprint = attributes[prefix + 'consent'] + '|' + attributes[prefix + 'oppref'] + '|' + cart.token;
    if (fingerprint === lastWritten) return;
    const saved = await nativeFetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes }),
    });
    if (saved.ok) lastWritten = fingerprint;
  }
  function sync() {
    pending = true;
    running = running.catch(() => {}).then(async () => {
      if (!pending) return;
      pending = false;
      try { await update(); } catch (_) { /* Un fallo de seguimiento nunca debe impedir comprar. */ }
    });
    return running;
  }
  function refresh() { lastWritten = ''; sync(); }
  document.addEventListener('visitorConsentCollected', refresh);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:refresh', refresh);

  // Observar las altas al carrito realizadas por fetch, conservando respuesta y errores originales.
  window.fetch = function (...args) {
    const result = nativeFetch(...args);
    const input = args[0];
    const url = typeof input === 'string' ? input : input?.url || '';
    if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(url)) {
      result.then(response => { if (response.ok) refresh(); }, () => {});
    }
    return result;
  };
  // XHR y formularios de temas antiguos: comprobar despues de una accion de anadir.
  document.addEventListener('click', event => {
    if (event.target.closest?.('[name="add"], [data-add-to-cart]')) {
      setTimeout(refresh, 700); setTimeout(refresh, 1800);
    }
  }, true);

  // Antes del checkout normal, esperar como maximo 1,5 segundos sin bloquear una compra.
  let passing = false;
  document.addEventListener('submit', event => {
    const form = event.target;
    const button = event.submitter;
    if (passing || !button || !form.matches?.('form') || button.name !== 'checkout') return;
    event.preventDefault();
    Promise.race([sync(), new Promise(resolve => setTimeout(resolve, 1500))]).finally(() => {
      passing = true;
      try { form.requestSubmit(button); } finally { passing = false; }
    });
  }, true);
  document.addEventListener('click', event => {
    const anchor = event.target.closest?.('a[href]');
    if (!anchor || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    let url;
    try { url = new URL(anchor.href, window.location.href); } catch (_) { return; }
    if (url.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?checkout(?:\/|$)/.test(url.pathname)) return;
    event.preventDefault();
    Promise.race([sync(), new Promise(resolve => setTimeout(resolve, 1500))]).finally(() => window.location.assign(url.href));
  }, true);

  function start() {
    if (window.Shopify?.customerPrivacy) { sync(); return; }
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
        if (!error) refresh();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
